<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">New Front</span>
        </v-card-title>
        <v-card-text>
          <v-row no-gutters>
            <v-col sm="12" md="6" class="pa-1">
              <v-text-field
                label="client id*"
                placeholder="Client ID..."
                outlined
                :rules="[
                    () => isIDValid || 'This field is required, and must contain 3 letters at least',
                    () => isIdBeginValid || 'This field must begin with `front-`.',
                ]"
                v-model="id"
                required
                dense
              ></v-text-field>
            </v-col>
            <v-col sm="12" md="6" class="pa-1">
              <v-text-field
                label="name*"
                placeholder="Front Name..."
                outlined
                :rules="[
                    () => isNameValid || 'This field is required, and must contain 3 letters at least',
                ]"
                v-model="name"
                required
                no-resize
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" class="pa-1">
              <v-textarea
                label="Description"
                placeholder="Description..."
                height="75"
                outlined
                dense
                v-model="description"
                counter
                :maxlength="130"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" class="pa-1">
              <v-text-field label="url" placeholder="URL..." outlined v-model="rootUrl"></v-text-field>
            </v-col>
          </v-row>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="cancel">Close</v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="save"
            :disabled="!isValid"
            :loading="isLoading"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isLoading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: { dialog: { type: Boolean, required: true } },
  data() {
    return {
      name: "",
      id: "",
      description: "",
      rootUrl: ""
    };
  },
  computed: {
    ...mapState({
      isLoading: state => state.fronts.createOne.pending
    }),
    isValid() {
      return this.isIDValid && this.isNameValid && this.isIdBeginValid;
    },
    isIDValid() {
      return this.id.length >= 9;
    },
    isIdBeginValid() {
      return this.id.startsWith("front-");
    },
    isNameValid() {
      return this.name.length >= 3;
    }
  },
  methods: {
    reset() {
      this.id = "";
      this.name = "";
      this.description = "";
      this.rootUrl = "";
    },
    cancel() {
      this.$emit("cancel");
      this.reset();
    },
    save() {
      this.$emit("save", this.id, this.name, this.description, this.rootUrl);
    }
  }
};
</script>